<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app dark class="d-print-none app app-bar">
    <v-app-bar-nav-icon v-if="home_url != '/home'" @click.stop="toggleDrawer" />
    <v-toolbar-title class="ml-0 pl-0" style="margin-right: -20%;">
      <!-- <img
      width="80px"
      v-if="org_logo!=null"
        :src="org_logo"
        alt=""
      /> -->
      <!-- <span>{{ org_name }} </span> -->
      {{ org_name }}

      <!-- <marquee v-if="payment_due_date" behavior="scroll" direction="left" scrollamount="5">
           {{ payment_due_date }}
      </marquee> -->

      <!-- <img
    class="hidden-sm-and-down erp_logo"
        src="https://eduplusschool.s3.ap-south-1.amazonaws.com/edupluscampus.png"
      />   -->
    </v-toolbar-title>
    <v-spacer />
    <v-avatar>
      <span v-if="is_school_bypass_login">
        <!-- <router-link to="/bypass-management-inst"> -->
        <v-icon @click="bypasslogout()" title="Bypass Logout" class="icon">mdi-location-exit</v-icon>
        <!-- </router-link> -->
      </span>
    </v-avatar>
    <div v-if="tenant == 'wws' && org_id == '1' && usertype == 'Employee'">
      <a href='https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Leave+policy_WWS.pdf' target="blank" class="ml-6">
        <v-icon title="Leave policy" class="mr-4">mdi-eye </v-icon>
      </a>
    </div>
    <div v-if="tenant == 'wws' && org_id == '2' && usertype == 'Employee'">
      <a href='https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Leave+policy_WWS+Hadapsar.pdf' target="blank"
        class="ml-6">
        <v-icon title="Leave policy" class="mr-4">mdi-eye </v-icon>
      </a>
    </div>

    <div v-if="show_calendar">
      <v-icon title="Calender Of Events" @click="OpenDialogBoxForShowCalender()">mdi-calendar</v-icon>
    </div>
    <div>
      <v-dialog v-model="DialogBoxForShowCalender" width="500" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Notification
          </v-card-title>

          <v-card-text v-if="conf_value != null && conf_link != null">
            <v-row>
              <v-col cols="12">
                <li style="padding-left: 0.3em; font-size: medium; font-weight: bold;" v-html="conf_value"></li>
              </v-col>
              <v-col cols="12">
                <span style="font-size: medium; font-weight: bold;">
                  Attachment:
                </span>
                <a :href="conf_link" target="_blank">
                  <v-icon color="green">
                    mdi-attachment
                  </v-icon>
                </a>
                <span>
                </span>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="justify-center"><v-btn color="primary" text @click="cancelDialogBoxForShowCalender()"
              outlined>
              Close
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div style="width: 10px"></div>
    <div v-if="feedback_notification_count > 0">
      <v-menu v-model="menu_for_feedback" :close-on-content-click="false" offset-x transition="scroll-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-badge color="red" overlap>
            <template v-slot:badge>
              <span>{{ feedback_notification_count }}</span>
            </template>
            <v-icon title="Feedbacks" v-bind="attrs" v-on="on">
              mdi-bell
            </v-icon>
          </v-badge>
        </template>
        <v-card>
          <v-list shaped>
            <v-list-item-group color="primary">
              <router-link v-if="resolve_feedback_link" :to="resolve_feedback_link" class="sidebar-link">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="warning">mdi-message-reply-text</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>FeedBack</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </v-list-item-group>
          </v-list>

        </v-card>
      </v-menu>
    </div>
    <div style="width: 10px"></div>


    <router-link to="/home">
      <v-icon class="icon">mdi-home</v-icon>
    </router-link>
    <v-avatar v-if="usertype == 'Parent'">
      <v-icon title="Analytical Dashboard" @click="analyticalStats()">mdi-gauge</v-icon>
    </v-avatar>
    <v-avatar v-if="usertype == 'Employee'">
      <v-icon title="Analytical Dashboard" @click="analyticalStatsEmp()">mdi-gauge</v-icon>
    </v-avatar>
    <!-- <v-avatar>
      <v-icon title="Technical Query" @click="routeToQuery()">mdi-help</v-icon>
    </v-avatar> -->
    <v-avatar>
      <v-icon title="Frequently Ask Questions" @click="faq" size="30">mdi-information-variant</v-icon>
    </v-avatar>

    <div class="text-right mb-2 mt-2 hidden-sm-and-down">
      <v-avatar v-if="!firefoxAgent" class="ma-2 white--text" size="50" outlined>
        <Speed />
      </v-avatar>
    </div>
    <!-- <v-btn icon>
      
      <v-avatar >
      <v-icon>mdi-bell</v-icon>
      </v-avatar>
    </v-btn> -->
    <div style="width: 10px"></div>
    <div style="background: white; border-radius: 100%">
      <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x
        transition="scroll-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <span v-if="false">
              <v-avatar>
                <v-img :src="awspath + profile_image_path + profile_image_name"></v-img>
              </v-avatar>
            </span>
            <span v-else>
              <v-avatar color="white">
                <span class="text headline">{{ initials }}</span>
              </v-avatar>
            </span>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <span v-if="profile_image_path">
                  <v-avatar>
                    <v-img :src="awspath + profile_image_path + profile_image_name"></v-img>
                  </v-avatar>
                </span>
                <span v-else>
                  <v-avatar color="white">
                    <span class="text headline">{{ initials }}</span>
                  </v-avatar>
                </span>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Hello, {{ username }}</v-list-item-title>
                <v-list-item-subtitle>{{ uid }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list shaped>
            <v-list-item-group color="primary">
              <router-link :to="profile" class="sidebar-link" v-if="profile">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="warning">mdi-account-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>User Profile</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
              <template v-if="ut == 'Parent'">
                <router-link :to="{ name: 'new-application-form' }" class="sidebar-link" v-if="profile">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="warning">mdi-account-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>New Admission Form</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
              </template>
              <!-- new-application-form -->
              <router-link :to="virtual_card" class="sidebar-link" v-if="virtual_card">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="warning">mdi-account-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Virtual Card</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>

              <router-link to="/update-password" class="sidebar-link">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="warning">mdi-lock-reset</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Change Password</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </v-list-item-group>
          </v-list>

          <v-card-actions>
            <v-btn small color="error" v-if="show_bypasslogout" @click="bypasslogout()" title="logout">
              By-pass Logout
            </v-btn>
            <v-spacer></v-spacer>
            <span @click="closeMenuAndLogout()" style="cursor: pointer; color: #b71c1c"><b> Sign Out </b></span>
            <v-btn class="ma-1" outlined small fab color="error" @click="closeMenuAndLogout()" title="logout">
              <v-icon>mdi-location-exit</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
  </v-app-bar>
</template>
<script>
import axios from "axios";
import Speed from "./Speed";
export default {
  components: {
    Speed,
  },
  data: () => ({
    initials: "",
    menu: false,
    username: "",
    uid: "",

    data: {},
    profile_image_name: "",
    profile_image_path: "",
    profile: null,
    home_url: null,
    virtual_card: "",
    firefoxAgent: false,
    show: false,
    org_name: null,
    org_logo: "https://eduplusschool.s3.ap-south-1.amazonaws.com/edupluscampus.png",
    usertype: null,
    show_bypasslogout: false,
    ut: null,
    tenant: null, reload_cnt: 3, is_school_bypass_login: false,
    DialogBoxForShowCalender: false,
    feedback_notification_count: 0,
    resolve_feedback_link: "",
    menu_for_feedback: false,
    conf_link: "",
    conf_value: "",
    show_calendar: false,
    org_id: null,
    payment_due_date:localStorage.getItem("payment_due_date")
  }),
  created() {
    this.virtual_card = "/role-dashboard/virtual-card";
    this.tenant = localStorage.getItem("EPS-tenant");
    this.org_id = localStorage.getItem("EPS-org-id");

    if (localStorage.getItem("EPS-ut") == "Parent") {
      if (this.tenant == "wws" || this.tenant == "vvp" || this.tenant == "eps" || this.tenant == "sbpps" || this.tenant == "sanjivani" || this.tenant == "saisa") {
        this.ut = "Parent";
      }
      this.profile = "/role-dashboard/edit-child-profile";
    } else if (localStorage.getItem("EPS-ut") == "Employee") {
      this.profile = "/role-dashboard/edit-emp-profile";
    } else {
      this.profile = null;
    }
  },
  methods: {
        clearSessionStroge() {

            sessionStorage.removeItem("emp_role");
            sessionStorage.removeItem("sblinks");
            sessionStorage.removeItem("para_role");
            sessionStorage.removeItem("para_role_type");
        },
    cancelDialogBoxForShowCalender() {
      this.DialogBoxForShowCalender = false;

    },
    OpenDialogBoxForShowCalender() {
      this.DialogBoxForShowCalender = true;
    },
    getParentNotification() {
      // alert("in getCalandar")
      axios
        .get("communication/getParentNotification")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.show_calendar = res.data.show_calendar
            this.conf_value = res.data.conf_value
            this.conf_link = res.data.conf_username
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    getCalandar() {
      axios
        .get("communication/getNotificationsCount")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.feedback_notification_count = res.data.new_feedback_list;
            this.resolve_feedback_link = res.data.resolve_feedback_link;

          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    toggleDrawer() {
      this.$store.state.drawer = !this.$store.state.drawer;
    },
    faq() {
      this.$router.push("/question-answer");
    },
    analyticalStats() {
      this.$router.push("role-dashboard/analytical-dashboard");
    },
  analyticalStatsEmp() {

  this.clearSessionStroge();
  window.location.href = "/inst-analytical-dashboard";
},
    closeMenuAndLogout() {
      this.menu = false;
      axios
        .get("login/logout")
        .then((res) => {
          console.log(res.data)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          localStorage.clear();
          this.$router.push("/");
        });
      // alert("hi")

      return;
    },
    bypasslogout() {
      this.menu = false;
      localStorage.setItem("EPS-token", localStorage.getItem("Mngt-EPS-token"));
      localStorage.setItem("EPS-uid", localStorage.getItem("Mngt-EPS-uid"));
      if (this.is_school_bypass_login) {
        // alert("ifff")
        this.$router.push("/bypass-management-inst");
        return;
      }
      this.$router.push("/eps-management-home");
      return;
    },
    routeToQuery() {
      if (localStorage.getItem("EPS-ut") == "Student") {
        this.$router.push("/role-dashboard/add-query");
      } else if (localStorage.getItem("EPS-ut") == "Employee") {
        this.$router.push("/role-dashboard/add-instructor-query");
      } else if (localStorage.getItem("EPS-ut") == "Parent") {
        this.$router.push("/role-dashboard/add-query");
      }
    },
    imageReplacement(uername) {
      //var names = this.uername.split('');
      //console.log("names "+names)
      this.initials = uername.charAt(0).toUpperCase();
      // window.alert(initials)
    },
  },
  mounted() {
    this.getParentNotification();
    this.getCalandar();
    this.is_school_bypass_login = localStorage.getItem("is_school_bypass_login")
    this.reload_cnt--;
    this.home_url = this.$route.fullPath; //will get currentPath
    // console.log("url is", this.home_url);
    // console.log("mngt", localStorage.getItem("Mngt-EPS-uid"));
    if (localStorage.getItem("Mngt-EPS-uid") != null)
      this.show_bypasslogout = true;

    this.$store.commit("setquick_links", true);
    this.$store.commit("setcalendar_flag", true);
    this.$store.commit("settoday_events", true);

    this.awspath = localStorage.getItem("awspath");
    this.uid = localStorage.getItem("EPS-uid");
    this.org_name = localStorage.getItem("EPS-org-name");
    this.org_logo = localStorage.getItem("EPS-org-logo");
    this.usertype = localStorage.getItem("EPS-ut");
    this.username = localStorage.getItem("username");
    this.profile_image_name = localStorage.getItem("profile_image_name");
    this.profile_image_path = localStorage.getItem("profile_image_path");
    this.imageReplacement(this.username);
    // alert("hi"+this.username+" - "+this.uid+" "+this.profile_image_name)
    // axios
    //   .get("home/getusername")
    //   .then((res) => {
    //     //window.console.log("res"+res.data)
    //     if (res.data.msg == "200") {
    //       this.data = res.data;
    //       this.uername = this.data.username;
    //       // window.alert(this.uername)
    //       this.profile_image_name = this.data.profile_image_name;
    //       this.profile_image_path = this.data.profile_image_path;
    //       this.imageReplacement(this.uername);
    //     } else {
    //     }
    //   })
    //   .catch((error) => {
    //     window.console.log(error);
    //      if (this.reload_cnt > 0) {
    //         this.onLoad();
    //         return;
    //       }
    //   })
    //   .finally(() => {
    //     console.log("finally")
    //     // this.overlay = false;
    //     console.log("reload:" + this.reload_cnt);
    //   });
  },
};
</script>
<style scoped>
.sidebar-link {
  text-decoration: none;
}

.sidebar-link-item:hover {
  background-color: rgb(181, 186, 190) !important;
}

.app {
  background: #9575DE;
}

.app1 {
  background: linear-gradient(to right,
      rgb(41, 128, 185),
      rgb(109, 213, 250),
      rgb(41, 128, 185));
  /*#0F2027;  /* fallback for old browsers */
  /* background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);  Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right, #2C5364, #203A43, #0F2027); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.text {
  color: #0f2027;
}

.org-name {
  color: rgb(255, 255, 255);
  font-family: "Comic Sans MS", "Comic Sans", cursive;
  font-size: 1.5em;
  /* margin-left: -3%; */
}

@media (max-width: 920px) {
  .org-name {
    color: rgb(255, 255, 255);
    font-family: "Comic Sans MS", "Comic Sans", cursive;
    font-size: 1em;
    margin-left: 0px;

    width: 100%;
  }

  .text {
    color: #0f2027;
    font-size: 20px !important;
  }

  .app-bar {
    height: 70px !important;
  }
}

@media (max-width: 310px) {
  .org-name {
    color: rgb(255, 255, 255);
    font-family: "Comic Sans MS", "Comic Sans", cursive;
    font-size: 13px;
    margin-left: 0px;
    width: 100%;
    font-weight: bold;
  }

  .app-bar {
    height: 70px !important;
  }

  /* .text {
    color: #0f2027;
    font-size: 10px !important;
  } */
}

.erp_logo {
  width: 33%;
  padding-top: 2%;
}
</style>